import { render, staticRenderFns } from "./SysCustomFormList.vue?vue&type=template&id=44a22c9f&scoped=true"
import script from "./SysCustomFormList.vue?vue&type=script&lang=js"
export * from "./SysCustomFormList.vue?vue&type=script&lang=js"
import style0 from "./SysCustomFormList.vue?vue&type=style&index=0&id=44a22c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a22c9f",
  null
  
)

export default component.exports